export const VEHICLE_SELECTION_LOADING = "VEHICLE_SELECTION_LOADING";
export const VEHICLE_SELECTION_SUCCESS = "VEHICLE_SELECTION_SUCCESS";
export const VEHICLE_SELECTION_FAILURE = "VEHICLE_SELECTION_FAILURE";

export interface VehicleSelectionLoading {
  type: typeof VEHICLE_SELECTION_LOADING;
}

export interface VehicleSelectionSuccess {
  type: typeof VEHICLE_SELECTION_SUCCESS;
  payload: string;
}

export interface VehicleSelectionFailure {
  type: typeof VEHICLE_SELECTION_FAILURE;
}

export type VehicleSelectionDispatchTypes =
  | VehicleSelectionLoading
  | VehicleSelectionSuccess
  | VehicleSelectionFailure;
